import { TransactionColumn } from "../../../common/types/views/transactionViews";
import { ViewConfig } from "../../../lib/views";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { TransactionSortValue } from "../useSort";
import { AccountCell } from "./AccountCell";
import { ActionsCell } from "./ActionsCell";
import { AmountCell } from "./AmountCell";
import { CategoryCell } from "./CategoryCell";
import { ClassesCell } from "./ClassesCell";
import { DateCell } from "./DateCell";
import { DescriptionCell } from "./DescriptionCell";
import { EntityCell } from "./EntityCell";
import { SplitCell } from "./SplitCell";

export const transactionsViewConfig: ViewConfig<
    TransactionListItemDto,
    TransactionColumn,
    TransactionSortValue
> = {
    columns: {
        [TransactionColumn.DATE]: {
            accessorKey: "date",
            name: "Date",
            cell: DateCell,
            sort: {
                asc: TransactionSortValue.DATE_ASC,
                desc: TransactionSortValue.DATE_DESC,
            },
        },
        [TransactionColumn.DESCRIPTION]: {
            accessorKey: "bankDescription",
            name: "Description",
            cell: DescriptionCell,
            sort: {
                asc: TransactionSortValue.DESCRIPTION_ASC,
                desc: TransactionSortValue.DESCRIPTION_DESC,
            },
        },
        [TransactionColumn.CATEGORY]: {
            accessorKey: "category.label",
            name: "Category",
            cell: CategoryCell,
            sort: {
                asc: TransactionSortValue.CATEGORY_ASC,
                desc: TransactionSortValue.CATEGORY_DESC,
            },
        },
        [TransactionColumn.ACCOUNT]: {
            accessorKey: "financialAccount.name",
            name: "Account",
            cell: AccountCell,
            sort: {
                asc: TransactionSortValue.ACCOUNT_ASC,
                desc: TransactionSortValue.ACCOUNT_DESC,
            },
        },
        [TransactionColumn.AMOUNT]: {
            accessorKey: "amount",
            name: "Amount",
            cell: AmountCell,
            sort: {
                asc: TransactionSortValue.AMOUNT_ASC,
                desc: TransactionSortValue.AMOUNT_DESC,
            },
        },
        [TransactionColumn.COUNTERPARTY]: {
            accessorKey: "counterparty",
            name: "Counterparty",
        },
        [TransactionColumn.NOTE]: {
            accessorKey: "memo",
            name: "Note",
        },
        [TransactionColumn.RECEIPTS]: {
            accessorKey: "receipts",
            name: "Receipts",
        },
        [TransactionColumn.SPLIT]: {
            accessorKey: "splitParentId",
            name: "Split",
            cell: SplitCell,
        },
        [TransactionColumn.ENTITY]: {
            accessorKey: "entity",
            name: "Entity",
            cell: EntityCell,
        },
        [TransactionColumn.CLASSES]: {
            accessorKey: "classAssignments",
            name: "Class",
            cell: ClassesCell,
            sort: {
                asc: TransactionSortValue.CLASS_ASC,
                desc: TransactionSortValue.CLASS_DESC,
            },
        },
        [TransactionColumn.ACTIONS]: {
            accessorKey: "requiredActions",
            name: "Action",
            cell: ActionsCell,
            sort: {
                asc: TransactionSortValue.ACTIONS_ASC,
                desc: TransactionSortValue.ACTIONS_DESC,
            },
        },
    },
};
